import { graphql, useStaticQuery } from 'gatsby';
import { getDocumentDataList, getHeroIntro, getCategoryList } from '../utils/utils';

function getDocumentLibraryData() {
  const raw_data = useStaticQuery(graphql`
    query documentLibraryQuery {

      allSanityPage(filter: { slug: { current: { eq: "resource-center" } } }) {
        edges {
          node {
            _rawBody
            body {
              ... on SanityReferenceLibraryMedia {
                SelectCategory {
                  CategoryTitle
                }
              }
            }
          }
        }
      }
      allSanityReferenceLibraryMedia{
      edges{
        node {
        ResourceTitle
        _rawFileUpload
        _rawImage
        ResourceDescription
        showDownloadButton
        SelectCategory {
          CategoryTitle
        }
      }
      }
      }
      allSanityMediacategory {
        nodes {
          CategoryTitle
        }
      }
    }
  `);
  const jsonData = {
    hero: getHeroIntro(raw_data.allSanityPage.edges[0].node._rawBody),
    mediaData: getDocumentDataList(raw_data.allSanityReferenceLibraryMedia, raw_data.allSanityPage.edges[0].node.body),
    categoryList: getCategoryList(raw_data.allSanityMediacategory.nodes),
  };
  return jsonData;
}

export default getDocumentLibraryData;
